import { InjectionToken } from '@angular/core';
import { LaunchConfig } from '@shared/data-access/interfaces';

export const LAUNCHCONFIG = new InjectionToken<LaunchConfig>('LAUNCHCONFIG');
